import React from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { Form, Content } from 'ui'
import { tryCatch } from 'utils'

import { FormProps, SubmitHandler } from './types'
import { useEffect } from 'react'

const BatchActionSchema = Yup.object().shape({
  action: Yup.string().required(),
})

export interface BatchActionFormValues {
  [key: string]: string | undefined
  action?: string | undefined
}

export type BatchActionSubmitHandler = SubmitHandler<BatchActionFormValues>

interface BatchActionFormProps extends FormProps<BatchActionFormValues> {}

const FORM_CONTAINER_STYLES: string = 'flex flex-col flex w-full mb-6'
const BUTTON_WRAPPER_STYLES: string = 'flex items-center mb-auto'
const FORM_STYLES: string = 'flex flex-col flex'
const BUTTON_STYLES: string = 'w-full sm:w-auto'

export const BATCH_ACTION_EDIT = 'Edit'
export const BATCH_ACTION_DELETE = 'Delete'

const BATCH_ACTIONS = [BATCH_ACTION_EDIT, BATCH_ACTION_DELETE]

export const BatchActionForm: React.FC<BatchActionFormProps> = ({
  onSubmit: externalSubmitHandler,
  defaultValues,
}) => {
  const {
    handleSubmit,
    register,
    errors,
    setValue,
    setError,
    formState,
    watch,
  } = useForm<BatchActionFormValues>({
    mode: 'onBlur',
    resolver: yupResolver(BatchActionSchema),
  })

  const { action: currentAction } = watch(['action'])

  useEffect(() => {
    if ((currentAction?.length ?? 0) < 1) {
      setValue('action', defaultValues?.action)
    }
  })

  const onSubmit = handleSubmit(async (data: BatchActionFormValues) => {
    await tryCatch(
      async () => {
        const errors = (await externalSubmitHandler(data)) ?? []
        if (errors?.length) {
          errors.forEach(({ path, message }) =>
            setError(path as any, { message })
          )
        }
      },
      (error: Error) => {
        setError('_', error)
      }
    )
  })

  return (
    <div className={FORM_CONTAINER_STYLES}>
      <form className={FORM_STYLES} onSubmit={onSubmit}>
        <Form.Fields nested register={register} errors={errors} grow>
          <Form.DropdownField
            name="action"
            placeholder="Choose Action..."
            value={currentAction ?? defaultValues?.action}
            className="w-full"
            hideSearch
          >
            {() =>
              BATCH_ACTIONS.map((s) => {
                const handleClick = () => setValue('action', s)
                return (
                  <Form.DropdownItem onClick={handleClick} key={s}>
                    {s}
                  </Form.DropdownItem>
                )
              })
            }
          </Form.DropdownField>
          <div className={BUTTON_WRAPPER_STYLES}>
            <Content.ActionButton
              label="Go"
              type="submit"
              loading={formState.isSubmitting}
              className={BUTTON_STYLES}
            />
          </div>
        </Form.Fields>
        <Form.ErrorComponent error={(errors as any)['_']?.message} />
      </form>
    </div>
  )
}
